export const apiBaseUrl = 'https://apiops.x1jets.com'
export const yourJetcardFrontUrl = "https://yourjetcards.x1jets.com"
export const yourFlightFrontUrl = "https://yourflight.x1jets.com"
export const yourBriefFrontUrl = "https://yourbrief.x1jets.com"
export const yourAccessCardFrontUrl = 'https://yourmobilitycards.x1jets.com'
